// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Loader = require("../../../uikit/reason/atoms/Loader/Loader.bs.js");
let MainLayout = require("../components/MainLayout.bs.js");
let UserSession = require("./UserSession.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let UserSessionFetchErrorMessage = require("./UserSessionFetchErrorMessage.bs.js");

function LoggedInAgent$Provider(props) {
  let __loaderComponent = props.loaderComponent;
  let loaderComponent = __loaderComponent !== undefined ? __loaderComponent : JsxRuntime.jsx(Loader.make, {});
  let initState = UserSession.useInitState();
  switch (initState) {
    case "NotCalled" :
    case "Loading" :
      return loaderComponent;
    case "Agent" :
      return props.children;
    default:
      return JsxRuntime.jsx(MainLayout.make, {
        children: JsxRuntime.jsx(UserSessionFetchErrorMessage.make, {})
      });
  }
}

let Provider = {
  make: LoggedInAgent$Provider
};

let provider = LoggedInAgent$Provider;

exports.Provider = Provider;
exports.provider = provider;
/* Loader Not a pure module */
